import React from "react"
import { Link as RouterLink } from "react-router-dom"
import { Button, Box, Typography, Container } from "@mui/material"
import { useEffect } from "react"
function ApproveSuccess() {
  useEffect(() => {
    document.title = "BGA Warranty | Pricing Approved"
  }, [])
  return (
    <Container
      sx={{
        height: "80vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box textAlign="center">
        <Typography variant="h4" gutterBottom>
          Pricing Approved Successfully!
        </Typography>
        <Typography variant="body1" gutterBottom>
          The claim pricing has now been approved. Thank you.
        </Typography>
        <Button
          variant="contained"
          color="secondary"
          component={RouterLink}
          to="/dashboard"
          sx={{ marginTop: 5 }}
        >
          Back to Home
        </Button>
      </Box>
    </Container>
  )
}

export default ApproveSuccess
